import { createContext, useContext, useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import countries from 'i18n-iso-countries';
import languages from '@cospired/i18n-iso-languages';

import useStickyState from './useStickyState';

import enMessages from '../lang/en.json';

export const IntlWrapperContext = createContext(null);

const IntlWrapperProvider = (props: any) => {
	const [ i18nCountries, setI18nCountries] = useState({});
	const [ i18nLanguages, setI18nLanguages] = useState({});
	const [ locale, setLocale] = useStickyState('en', 'locale');
	const [ messages, setMessages ] = useState(enMessages);
	const { children } = props;

	useEffect(() => { 
		if (locale) {
			setI18nCountries(countries.getNames(locale));
			setI18nLanguages(languages.getNames(locale));
		} else {
			setI18nCountries(countries.getNames('en'));
			setI18nLanguages(languages.getNames('en'));
		}

		switch(locale) {
			case 'en':
				setMessages(enMessages);
				break;
			default: 
			setMessages(enMessages);
		}
	}, [locale]);

	const getI18nCountryName = (code: string) => {
		return countries.getName(code, locale);
	}

	const getI18nLanguageName = (code: string) => {
		return languages.getName(code, locale);
	}

  return (
		<IntlWrapperContext.Provider value={{
			getI18nCountryName,
			getI18nLanguageName,
			i18nCountries,
			i18nLanguages,
			locale,
			setLocale,
		}} {...props} >
			<IntlProvider
				key={locale}
				locale={locale}
				messages={messages}
				defaultLocale="en"
			>
				{children}
			</IntlProvider>
		</IntlWrapperContext.Provider>
	);
};

export const useIntlWrapperContext = (): any => useContext(IntlWrapperContext);

export default IntlWrapperProvider;